import * as React from "react";
import FacebookLogin from "react-facebook-login";
import { Typography, TextField, Button } from "@material-ui/core";
import Axios from "axios";
import { FacebookProvider, EmbeddedPost, LoginButton } from "react-facebook";
import { FacebookVirality } from "./facebookVirality";
interface Props {}
interface State {}
export default class Tools extends React.Component<Props, State> {
  state = {
    logined: false,
    userInfo: undefined,
    url: "",
    engagement: undefined,
    checkURL: undefined
  };
  componentClicked = () => {
    //console.log("clicked");
  };
  onFacebookResponse = userInfo => {
    //console.log(userInfo);
    this.setState({ logined: true, userInfo: userInfo.tokenDetail });
  };
  checkURL = () => {
    this.setState({ checkURL: this.state.url });
  };
  renderLogin = () => {
    if (!this.state.logined) {
      return (
        <div style={{}}>
          <FacebookLogin
            appId="213471075795721"
            autoLoad={true}
            fields="name,email,picture"
            onClick={this.componentClicked}
            callback={this.onFacebookResponse}
          />
          {/* <FacebookProvider appId="213471075795721">
            <LoginButton scope="email" onCompleted={this.onFacebookResponse}>
              <span>Login via Facebook</span>
            </LoginButton>
          </FacebookProvider> */}
        </div>
      );
    }
    return null;
  };
  renderSearchBar = () => {
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <TextField
          label="Enter URL"
          value={this.state.url}
          onChange={e => {
            this.setState({ url: e.target.value });
          }}
        />
        <Button color="primary" onClick={this.checkURL}>
          Check URL
        </Button>
      </div>
    );
  };
  renderEngagement = () => {
    if (this.state.engagement) {
      return (
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
            <Typography variant="caption">Total Interaction</Typography>
            <Typography>
              {this.state.engagement.reaction_count +
                this.state.engagement.comment_count +
                this.state.engagement.share_count +
                this.state.engagement.comment_plugin_count}
            </Typography>
          </div>
          <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
            <Typography variant="caption">Reaction Count</Typography>
            <Typography>{this.state.engagement.reaction_count}</Typography>
          </div>
          <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
            <Typography variant="caption">Comment Count</Typography>
            <Typography>{this.state.engagement.comment_count}</Typography>
          </div>
          <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
            <Typography variant="caption">Share Count</Typography>
            <Typography>{this.state.engagement.share_count}</Typography>
          </div>
          <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
            <Typography variant="caption">Comment Plugin Count</Typography>
            <Typography>
              {this.state.engagement.comment_plugin_count}
            </Typography>
          </div>
        </div>
      );
    }
  };
  render() {
    return (
      <div style={{ margin: 24, display: "flex", flexDirection: "column" }}>
        <Typography variant="headline">URL Checker</Typography>

        {this.renderSearchBar()}
        {this.state.checkURL && <FacebookVirality url={this.state.checkURL} />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/tools/index.tsx